/**
 * All possible dataversions in production. Used by migrations scripts and to determine the latest version.
 * Latest version shall ALWAYS have the highest value
 */
export enum DATA_VERSION {
  DATA_VERSION0 = 0,
  DATA_VERSION1 = 1,
  DATA_VERSION2 = 2,
  DATA_VERSION3 = 3,
  DATA_VERSION4 = 4,
  DATA_VERSION5 = 5,
  DATA_VERSION6 = 6,
  DATA_VERSION7 = 7,
  DATA_VERSION8 = 8,
  DATA_VERSION9 = 9,
  DATA_VERSION10 = 10,
  DATA_VERSION11 = 11,
  DATA_VERSION12 = 12,
  DATA_VERSION13 = 13,
  DATA_VERSION14 = 14,
  DATA_VERSION15 = 15,
  DATA_VERSION16 = 16,
  DATA_VERSION17 = 17,
  DATA_VERSION18 = 18,
  DATA_VERSION19 = 19,
  DATA_VERSION20 = 20,
  DATA_VERSION21 = 21,
  DATA_VERSION22 = 22,
  DATA_VERSION23 = 23,
  DATA_VERSION24 = 24,
  DATA_VERSION25 = 25,
  DATA_VERSION26 = 26,
  DATA_VERSION27 = 27,
  DATA_VERSION28 = 28,
  DATA_VERSION29 = 29,
  DATA_VERSION30 = 30,
  DATA_VERSION31 = 31,
  DATA_VERSION32 = 32,
}
